module.exports = __webpack_public_path__ + "img/reposicion.844c300d.png";